module.exports = __webpack_public_path__ + "03_glasses_black.fde4ceaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/03_glasses_black.png
// module id = DOtz
// module chunks = 0